import React, { useEffect, useState } from "react";
import "../../Opportunities/CardTabs/BattleCard.css";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
import { useDispatch, useSelector } from "react-redux";
import { fetchBattleCardMpRequest } from "../../../../../store/features/actions/meetingPrep/battleCardActions";
import { useParams } from "react-router-dom";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import { ValueSellingFrameworkPlaceholder } from "../../Opportunities/CardTabs/ValueSellingFramworkPlaceholder";

function replaceUnderSquarebySpace(word) {
  return word
    ?.replace(/[_\[\]]/g, ' ') // Replace underscores and square brackets with space
    .replace(/\s+/g, ' ')      // Normalize multiple spaces to single space
    .trim()                    // Remove leading/trailing spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
}



export default function MeetingPrepBattleCard({opportunityId}) {

  const dispatch = useDispatch();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { clientName, accountName } = useParams();
  const {battleCardMpData, battleCardLoading, error}= useSelector(state=>state?.battleCardMpReducer)
  
  

  useEffect(() => {
    if (opportunityId ) {
      dispatch(fetchBattleCardMpRequest({opportunityId}))
    }
  }, [opportunityId])
  
  useEffect(() => {

    if (error) {
      setStatus("Error loading data");
    }else{
      if (battleCardMpData) {
        delete battleCardMpData?._id;
        delete battleCardMpData?.opportunity_id;
      }
      setResult(battleCardMpData || []);
      setStatus("Completed!");
    }

  }, [battleCardMpData, error]);


  function generateCardContent(content) {
    if (!content) return null;
  
    const formatKey = (key) =>
      key
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, (char) => char.toUpperCase());
  
    const renderValue = (value, key = null) => {
      if (typeof value === 'string') {
        return (
          <div key={key || value} className="row">
            {key && <div className="col-md-5">
            <p className="opp_bat_para">
              {key && <span className="opp_bat_span">{formatKey(key)}: </span>}
            </p>
            </div>
            }
            
            <div className={`${!key ? 'col-md-12' : 'col-md-7 pl-0'} `} >
            <p className="opp_bat_para">
              {value}
            </p>
            </div>

          
          </div>
        );
      }


  
      if (Array.isArray(value)) {

        const hasObject = Array.isArray(value) && value.some(
          item => (item !== null && typeof item === 'object') || key === null
        );

        return (
          <div key={key} className="battleCardListTop row">
            {key && <span className="list_top_span col-md-5">{formatKey(key)}:</span>}
            <ul className={`battleCardListUl ${hasObject ? 'col-md-12 ml-2 pr-2' : 'col-md-7' }`} >
              {value.map((item, idx) => (
                <li key={idx}>{renderValue(item)}</li>
              ))}
            </ul>
          </div>
        );
      }
  
      if (typeof value === 'object') {
        return (
          <div key={key} style={{ marginBottom: 'auto' }}>
            {key && <strong>{formatKey(key)}:</strong>}
            <div style={{ marginLeft: key ? '1em' : 0 }}>
              {Object.entries(value || {}).map(([childKey, childValue]) =>
                renderValue(childValue, childKey)
              )}
            </div>
          </div>
        );
      }
  
      return (
        <div key={key}>
          {key && <strong>{formatKey(key)}: </strong>}
          {String(value)}
        </div>
      );
    };
  
    return (
      <div className="">
        {typeof content === 'string'
          ? <div>{content}</div>
          : renderValue(content)}
      </div>
    );
  }

  return (
<div className="battlecard_wrapper">

    {battleCardLoading == true || result === null ? (
            <div className="row w-100">
              <ValueSellingFrameworkPlaceholder numberOfCards={8} widthClass='col-md-6' />
            </div>
          ) : Object.keys(result).length === 0 ? (
            <div className="no-data-message">
             <NoDataComp
              message="Content is being generated"
              buttonText="Refresh"
              onButtonClick={() =>  dispatch(fetchBattleCardMpRequest({opportunityId}))}
             />
          </div>
          ) : (
            
    // <div className="row"> 
    // {
    //   Object.entries(result || {}).map(([key, value]) => (
    //     <div key={key} className="col-md-6">
    //       <div className="battle_card_block">
    //       <ThemedCardComponent
    //         title={replaceUnderSquarebySpace(key)}
    //         description={generateCardContent(value)}
    //       />
    //     </div>
    //     </div>
    //   ))
    // }
    // </div>

    <div className="row">
      <div className="col-md-6">
        {
          Object.entries(result || {}).filter((_, index) => index % 2 === 0).map(([key, value]) => (
            <div key={key} className="battle_card_block">
              <ThemedCardComponent
                title={replaceUnderSquarebySpace(key)}
                description={generateCardContent(value)}
              />
            </div>
          ))
        }
      </div>

      <div className="col-md-6">
        {
          Object.entries(result || {}).filter((_, index) => index % 2 === 1).map(([key, value]) => (
            <div key={key} className="battle_card_block">
              <ThemedCardComponent
                title={replaceUnderSquarebySpace(key)}
                description={generateCardContent(value)}
              />
            </div>
          ))
        }
      </div>
  </div>


  )}
</div>
  
  );
}
